<template>
  <div class="TechniquesDetailList margin-right-1-point-1-Perc">
    <div class="container-fluid">
      <div class="table-responsive margin-Top-3Perc margin-left-2Point7Perc">
        <table class="table table-striped ">
          <thead>
            <tr>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Name</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Aliases</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right display-none">Category</th>
              <th class="text-align-center text-valign-middle font-size-15px">Action</th>            
            </tr>
          </thead>
          <tbody>
            <tr v-for="techniqueObj in getAllTechniques" :key="techniqueObj.TechniqueId" v-bind:techObj = "techniqueObj" > 
              <td class="text-align-center text-valign-middle border-right">{{techniqueObj.TechniqueName}}</td>
              <td class="text-align-center text-valign-middle border-right">{{techniqueObj.Aliases}}</td>
              <td class="text-align-center text-valign-middle border-right display-none">{{techniqueObj.Category}}</td>
              <td class="text-align-center text-valign-middle">
                <a href="#" @click="openEditTechniqueOverlay($event,true,techniqueObj)"> Edit </a>|
                <a href="#" @click="openConfirmationOverlay($event,true,techniqueObj)"> Delete </a>
              </td>
            </tr>
          </tbody>
       </table>
      </div>
    </div>
    <update-technique-overlay v-if="openEditOverlay" @refreshTechniqueList="refreshTechniques" @showSpinner="updateShowSpinnerflag" @openEditOverlay="closeEditOverlay" v-bind:selectedTechniqueObj="selectedTechniqueObj"></update-technique-overlay>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTechniqueString" v-bind:postfixString="postDeleteTechniqueString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedTechnique"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>  
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { techniqueService } from '@/server-util/technique-service'
import UpdateTechnique from '@/components/UpdateTechniqueOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
export default {
  data: function () {
    return {
      openEditOverlay: false,
      selectedTechniqueObj: null,
      showSpinner: false,
      showConfirmationBox: false,
      prefixDeleteTechniqueString: 'Are you sure you want to delete ',
      postDeleteTechniqueString: '',
      showAlertDialog: false,
      errorMsg: ''
    }
  },
  name: 'TechniquesDetailList',
  methods: {
    refreshTechniques (value) {
      // AK: used when user edit's techniques
      if (value) {
        // AK: Re-emit refresh call to parent file (ChallengeTechniques file)
        this.$emit('refreshTechniqueList', true)
      }
    },
    updateShowSpinnerflag (value) {
      // AK: used to show and hide Spinner while processing Edit Technique
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    openEditTechniqueOverlay: function (event, flagToUpdate, techniqueObj) {
      // AK: Used when user pressed Edit Option to edit Technique
      this.openEditOverlay = flagToUpdate
      this.selectedTechniqueObj = techniqueObj
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    closeEditOverlay (value) {
      // AK: close Edit overlay
      this.openEditOverlay = value
      // AK: Enabled Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    openConfirmationOverlay ($event, flagToUpdate, techniqueObj) {
      // AK: Used to show confirmation dialog to user first
      this.selectedTechniqueObj = techniqueObj
      this.postDeleteTechniqueString = '\'' + this.selectedTechniqueObj.TechniqueName + '\' technique?'
      // AK: Show Confirmation Overlay
      this.showConfirmationBox = true
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Technique overlay
      this.showConfirmationBox = value
    },
    deleteSelectedTechnique (value) {
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.selectedTechniqueObj.TechniqueId !== undefined ||
          this.selectedTechniqueObj.length > 0
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          // AK: Hide Delete Confirmation Box
          _this.showConfirmationBox = false
          techniqueService
            .deleteTechnique(storeObj.state.access_token, _this.selectedTechniqueObj.TechniqueId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Technique List
                _this.$emit('refreshTechniqueList', true)
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Technique Object is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getAllTechniques: {
      get: function () {
        return this.$store.state.techniqueList
      }
    }
  },
  components: {
    'update-technique-overlay': UpdateTechnique,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.display-none {
  display: none;
}
.TechniquesDetailList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-Top-3Perc
{
	margin-top: 3%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
 }
 .text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.margin-right-3Point4Perc{
  margin-right:-3.4%;
}
.margin-left-2Point7Perc{
 margin-left: 2.7%;
}

margin-right{
  margin-right:1% !important;
}
.red-color{
  background-color:red; 
}
.margin-right-1-point-1-Perc{
  margin-right: 1.1% !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/components/TechniquesDetailList.vue